// Couleurs des carburants comme à la pompe (normes européennes)
const getFuelColor = (fuel) => {
  const name = (fuel.short_name || fuel.name || '').toLowerCase();
  
  if (name.includes('gazole') || name.includes('diesel') || name.includes('b7')) {
    return { bg: 'bg-yellow-400', text: 'text-black', border: 'border-yellow-500', selectedBg: 'bg-yellow-500' };
  }
  if (name.includes('e85') || name.includes('ethanol')) {
    return { bg: 'bg-amber-500', text: 'text-white', border: 'border-amber-600', selectedBg: 'bg-amber-600' };
  }
  if (name.includes('e10')) {
    return { bg: 'bg-emerald-400', text: 'text-black', border: 'border-emerald-500', selectedBg: 'bg-emerald-500' };
  }
  if (name.includes('sp95') || name.includes('95')) {
    return { bg: 'bg-green-500', text: 'text-white', border: 'border-green-600', selectedBg: 'bg-green-600' };
  }
  if (name.includes('sp98') || name.includes('98')) {
    return { bg: 'bg-green-600', text: 'text-white', border: 'border-green-700', selectedBg: 'bg-green-700' };
  }
  if (name.includes('gpl')) {
    return { bg: 'bg-blue-500', text: 'text-white', border: 'border-blue-600', selectedBg: 'bg-blue-600' };
  }
  return { bg: 'bg-gray-400', text: 'text-white', border: 'border-gray-500', selectedBg: 'bg-gray-500' };
};

export const FuelFilters = ({ fuels, selectedFuels, onToggleFuel }) => {
  if (!fuels || fuels.length === 0) return null;

  // Function to get display name
  const getDisplayName = (fuel) => {
    if (fuel.short_name && fuel.short_name.trim()) return fuel.short_name;
    // Shorten common fuel names
    const nameMap = {
      'Gazole': 'Gazole',
      'Super Sans Plomb 95': 'SP95',
      'Super Sans Plomb 98': 'SP98',
      'Super Sans Plomb 95 E10': 'E10',
      'Super Ethanol E85': 'E85',
      'GPLc': 'GPLc'
    };
    return nameMap[fuel.name] || fuel.name;
  };

  return (
    <div 
      data-testid="fuel-filters"
      className="bg-[#F3F4F6] dark:bg-gray-900 p-4"
    >
      <p className="text-xs font-bold uppercase tracking-widest text-gray-600 dark:text-gray-400 mb-3">
        Filtrer par carburant
      </p>
      <div className="flex overflow-x-auto gap-3 no-scrollbar pb-1">
        {fuels.map((fuel) => {
          const isSelected = selectedFuels.includes(fuel.id);
          const fuelColor = getFuelColor(fuel);
          return (
            <button
              key={fuel.id}
              onClick={() => onToggleFuel(fuel.id)}
              data-testid={`fuel-filter-${fuel.id}`}
              className={`filter-chip px-4 py-2 font-bold uppercase tracking-wider border-2 transition-all ${
                isSelected
                  ? `${fuelColor.selectedBg} ${fuelColor.text} ${fuelColor.border} shadow-hard-sm scale-105`
                  : `bg-white dark:bg-gray-800 text-gray-600 dark:text-gray-400 border-gray-300 dark:border-gray-600 hover:${fuelColor.bg} hover:${fuelColor.text} hover:${fuelColor.border}`
              }`}
            >
              <span className={`inline-block w-2 h-2 rounded-full mr-2 ${isSelected ? 'bg-white dark:bg-black' : fuelColor.bg}`} />
              {getDisplayName(fuel)}
            </button>
          );
        })}
      </div>
    </div>
  );
};
